import { Component, OnInit } from '@angular/core';
import { IUser } from '@interfaces/IUser';
import { selectProfile } from '@myStore/profile-view/profile-view.selector';
import { GetEmailTokenValidity } from '@myStore/profile/profile.actions';
import { select, Store } from '@ngrx/store';
import { IAppState } from '@myStore/app.state';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
})
export class VerifyEmailComponent implements OnInit {
  private token?: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private user$?: IUser;

  constructor(
    private _store: Store<IAppState>,
    private _route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this._store
      .pipe(select(selectProfile), takeUntil(this.destroy$))
      .subscribe(profile => {
        if (profile) {
          this.user$ = profile;
        }
      });

    this.token = this._route.snapshot.queryParams['token'];
    if (this.token && this.user$?.id) {
      this._store.dispatch(new GetEmailTokenValidity(this.token, this.user$));
    }
  }
}
